module.exports = __webpack_public_path__ + "img/xndc-banner.69319680.jpg";